import { useDispatch, useSelector } from 'react-redux';
import InputCheckboxGrid from './input-checkbox-grid.js';
import InputRadioGrid from './input-radio-grid.js';
import FadeIn from 'react-fade-in';

import cx from 'classnames';
export default function Question(props){
	const {
		type,
		choices,
		index,
		text
	} = props;
	const selection = useSelector( s => s.questions[index].selection )
	const dispatch = useDispatch();

	var InputComponent;
	switch( type ){
		case 'radio-grid':
			InputComponent = InputRadioGrid;
			break;
		case 'checkbox-grid':
		default:
			InputComponent = InputCheckboxGrid;
			break;
	}

	return <div className={ cx(
		"sr-question",
		"type-" + type
	) } >
		<label className="sr-question-title">
			<span className="number">{ index + 1 }</span>
			<span className="text">{ text }</span>
		</label>
		<InputComponent {...props} />
	</div>
}